/** Value Added Tax (VAT, rus. "НДС") amount value calcultor. Singleton object. */
export class VatAmountCalculator {
  private static instance: VatAmountCalculator = null;

  /** Get {@link VatAmountCalculator} instance. Create it if not exist. */
  public static getInstance(): VatAmountCalculator {
    if (!VatAmountCalculator.instance) {
      VatAmountCalculator.instance = new VatAmountCalculator();
    }
    return VatAmountCalculator.instance;
  }

  /**
   * Calculate Value Added Tax (VAT, rus. "НДС") amount value by VAT rate value
   *
   * @param amount Source amount value (number)
   * @param vatRate VAT rate value (number)
   *
   * @returns VAT amount value (number)
   */
  public getVatAmount = (amount: number, vatRate?: number): number => {
    const vatRateInternal = vatRate ?? 0;

    return vatRateInternal > 0
      ? (amount * vatRateInternal) / (vatRateInternal + 100)
      : 0;
  };
}
